module.exports = __webpack_public_path__ + "media/brands/moskwicz-19b358e3.png";